import NpsCheckout from './NpsCheckout';

export default NpsCheckout;
